import {Injectable} from '@angular/core';
import {GenericServicesMotoristaService} from './generic-services-motorista.service';
import {MensagensService} from 'max-ng-lib';
import {HttpClient} from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class LocalizacaoMotoristaService extends GenericServicesMotoristaService {

	constructor(
		private mensagensService: MensagensService,
		private httpClient: HttpClient) {
		super();
	}

	getMensagensService(): MensagensService {
		return this.mensagensService;
	}

	getHttpClient(): HttpClient {
		return this.httpClient;
	}

	getUrlRecurso(): string {
		return '/localizacaoMotorista';
	}

	informacoesMotoristas(filtro: {idsMotoristas: string[], idsFiliais: string[], idsVeiculos: string[]}) {
		return this.post<any[]>('/informacoesMotoristas', {dados: filtro, exibirLoading: false});
	}

	obterLocalizacoesMotorista(idMotorista: string, dataInicio?, dataFinal?, idCarregamento?) {
		const params: any = {};
		params.idMotorista = idMotorista;

		if (dataInicio) {
			params.dataInicio = dataInicio;
		}
		if (dataInicio) {
			params.dataFinal = dataFinal;
		}
		if (idCarregamento) {
			params.idCarregamento = idCarregamento;
		}

		return this.get<any>('/obterLocalizacoesMotorista', {dados: params, exibirLoading: false});
	}

	obterDetalheEntregasMotorista(params: {
		idMotorista,
		dataSaida,
		dataEntrega,
		idCarregamento
	}) {
		return this.get<any>('/obterDetalheEntregasMotorista', {dados: params, exibirLoading: false});
	}

	obterCentroDistribuicaoDaRota(idCarregamento) {
		return this.get<any>('/obterCentroDistribuicaoDaRota', {dados: {idCarregamento: idCarregamento}, exibirLoading: false});
	}

}
